import { render, staticRenderFns } from "./NotificationSnoozeCard.vue?vue&type=template&id=a5b62f7a&scoped=true"
import script from "./NotificationSnoozeCard.vue?vue&type=script&lang=js"
export * from "./NotificationSnoozeCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationSnoozeCard.vue?vue&type=style&index=0&id=a5b62f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b62f7a",
  null
  
)

export default component.exports